// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ph4Ah","truncatedText":"styles_truncatedText___XYwb","fullText":"styles_fullText__GG_dB","textContainer":"styles_textContainer__BGHFH"};